<div class="modal-header w-100 mb-3">
    <div class="modal-title">
        <h1>{{data.headerName}}</h1>
        <h6 class="subTitle text-start">Control Marihub processing fee here!</h6>
    </div>
    <i class=" close btn-close" (click)="onNoClick()"></i>
</div>
<div mat-dialog-content>
    <form #processingFeesForm="ngForm" (submit)="onSubmit()">
        <div class="row">
            <div class="col">
                <div class="w-100 input-field">
                    <mat-label>
                        Customs/Administration fees*
                    </mat-label>
                    <mat-form-field appearance="outline">
                        <input matInput [(ngModel)]="data.administrationFees" name="administrationFees" type="number"
                               required>
                        <span matSuffix class="hint">AED</span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="w-100 input-field">
                    <mat-label>
                        Port shipping fees*
                    </mat-label>
                    <mat-form-field appearance="outline">
                        <input matInput [(ngModel)]="data.portFees" name="portFees" type="number" required>
                        <span matSuffix class="hint">AED</span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="w-100 input-field">
                    <mat-label>
                        Packing Fees*
                    </mat-label>
                    <mat-form-field appearance="outline">
                        <input matInput [(ngModel)]="data.packingFees" name="packingFees" type="number" required>
                        <span matSuffix class="hint">AED</span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="w-100 input-field">
                    <mat-label>
                        VAT Percentage
                    </mat-label>
                    <mat-form-field appearance="outline">
                        <input matInput type="number" [(ngModel)]="data.vatPercentage" name="vatPercentage" required [max]="100">
                        <span matSuffix class="hint">%</span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!--<div class="row">
            <div class="col">
                Total Processing fee: {{ data.administrationFees + data.portFees + data.packingFees }}
            </div>
        </div>-->
        <!--<hr>-->
        <div mat-dialog-actions class="float-end modal-footer w-100">
            <button class="btn btn-secondary m-2" (click)="onNoClick()" type="button">Cancel</button>
            <button type="submit" class="btn btn-primary float-end m-2" [disabled]="!processingFeesForm.valid">
                Save Changes
            </button>
        </div>
    </form>
</div>
